module.exports = __webpack_public_path__ + "img/9788952748201.8d494871.jpg";